import React, { useState, useEffect } from 'react';
import api from '../../api';

const DynamicFaqSection = ({ page = 'home' }) => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [faqRes] = await Promise.all([
          api.get(`${process.env.REACT_APP_API_URL}/api/faqs/page/${page}`)
        ]);
        
        setFaqs(faqRes.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [page]);

  if (loading) return <></>;
  if (faqs.length === 0) return <></>;

  // Flatten FAQ items if grouped by category
  const allItems = faqs.flatMap(category => category.items);

  // Show only first 3 unless "View More" is clicked
  const visibleItems = showAll ? allItems : allItems.slice(0, 3);

  // Get the first category's image URL
  const firstCategoryWithImage = faqs.find(category => category.image_url);
  const categoryImageUrl = firstCategoryWithImage ? firstCategoryWithImage.image_url : null;

  return (
    <div className="edu-faq-area faq-style-12 section-gap-equal pb-5">
      <div className="container">
        <div className="row g-5 row--45 d-flex justify-content-center align-items-center">
          <div className="sec-title faq">
            <h2 className="text-center">FAQ</h2>
          </div>

          {/* FAQ Content */}
          <div className={`col-lg-6 order-2 order-md-1`}>
            <div className="edu-faq-content">
              <div className="faq-accordion" id="faq-accordion">
                <div className="accordion">
                  {visibleItems.map((item, index) => (
                    <div className="accordion-item" key={item.id}>
                      <h5 className="accordion-header">
                        <button 
                          className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                          type="button" 
                          data-bs-toggle="collapse"
                          data-bs-target={`#faq-${item.id}`}
                          aria-expanded={index === 0 ? 'true' : 'false'}
                        >
                          {item.question}
                        </button>
                      </h5>
                      <div 
                        id={`faq-${item.id}`} 
                        className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                        data-bs-parent="#faq-accordion"
                      >
                        <div className="accordion-body">
                          <p dangerouslySetInnerHTML={{ __html: item.answer }}></p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* View More / Less Button */}
              {allItems.length > 3 && (
                <div className="text-center mt-4">
                  <button 
                    className="btn btn-primary px-4 py-2"
                    onClick={() => setShowAll(!showAll)}
                  >
                    {showAll ? 'View Less' : 'View More'}
                  </button>
                </div>
              )}
            </div>
          </div>
          
          {/* FAQ Image - Show only if category has image */}
          {categoryImageUrl && (
            <div className={`col-lg-6 d-flex justify-content-center order-1 order-md-2`}>
              <div className="edu-faq-gallery">
                <div className="faq-thumbnail thumbnail-1">
                  <img 
                    src={`${process.env.REACT_APP_API_URL}/public/${categoryImageUrl}`} 
                    alt="FAQ Section" 
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DynamicFaqSection;